import { defineMessages } from 'react-intl';

export const errors = defineMessages({
  networkError: { id: 'gofre.error.network' },
  generic: { id: 'gofre.common.error.generic' },
});
